import React, {Component} from "react";
import { Link, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../../config.js';
import withRouter from './../withRouter';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Image from 'react-bootstrap/Image';

import ClipLoader from "react-spinners/ClipLoader";
import Spinner from 'react-bootstrap/Spinner';

const urlTypes = [
    {
        name: "Артефакт",
        type: "artefact"
    },
    {
        name: "IZI Travel",
        type: "izitravel"
    }
]

class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            item: {},
            loading: true,
            error: false,
            show_modal_update: false,
            show_modal_delete: false,
            title: "",
            uid: "",
            updating: false,
            isActive: false,
            activating: false,
            deleteIsComplete: false
        };

        this.item = this.item.bind(this)
        this.handleCloseUpdate = this.handleCloseUpdate.bind(this)
        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.handleChangeTitle = this.handleChangeTitle.bind(this)
        this.handleChangeUID = this.handleChangeUID.bind(this)
        this.update = this.update.bind(this)
        this.delete = this.delete.bind(this)
        this.handleChangeActive = this.handleChangeActive.bind(this)
        this.changeActive = this.changeActive.bind(this)
    }

    componentDidMount(){
        this.item()
    }

    item() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        item: result,
                        loading: false,
                        title: result.title,
                        uid:  result.uid,
                        isActive: result.isActive
                    });
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                });
            }
        ))

    }

    update() {
        const { title, uid } = this.state

        this.setState({
            updating: true,
            error: false
        })

        if (title === '') {
            this.setState({
                updating: false,
                error: "Не указано название"
            })
            return;
        }

        const requestOptions = {
            method: 'PUT',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({title, uid})
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        item: result,
                        title: result.title,
                        uid:  result.uid,
                        isActive: result.isActive,
                        show_modal_update: false
                    });
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }
    
                this.setState({
                    updating: false,
                });
            },
            (error) => {}
        ))
    }

    changeActive() {

        this.setState({
            activating: true
        })

        const requestOptions = {
            method: 'PUT',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({isActive: this.state.isActive})
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
            .then(res => res.json().then(
            (result) => {
                this.setState({
                    activating: false,
                });
            },
            (error) => {}
        ))   
    }

    delete() {

        this.setState({
            deleting: true,
            error: false
        })

        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        deleteIsComplete: true
                    })
                } else if (result.error) {
                    this.setState({
                        error: result.error.message,
                        deleting: false
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже.",
                        deleting: false
                    });
                }
            },
            (error) => {}
        ))
    }

    handleCloseUpdate() {
        this.setState({
            show_modal_update: false
        })
    }

    handleCloseDelete() {
        this.setState({
            show_modal_delete: false
        })
    }

    handleChangeTitle(event) {
        this.setState({title: event.target.value});
    }

    handleChangeUID(event) {
        let uri = event.target.value.replace(/[^a-z0-9]/gi, '')
        this.setState({uid: uri});
    }

    handleChangeActive(event) {
        this.setState({ isActive: event.target.checked },
            () => {
                this.changeActive()
            });
    }

    render() {

        let { item, loading, show_modal_update, show_modal_delete, updating, deleting } = this.state

        if (this.state.deleteIsComplete) {
            return (<Navigate to={"/"}/>)
        }

        return (
            <>
            <Row className="mb-4">
                <Col md={9} lg={6}>
                    <Row className="mb-4 d-flex justify-content-between">
                        <Col>
                            <Link to="/">&larr; Назад</Link>
                        </Col>
                        {!this.state.loading && (
                            <Col>
                                <Form className="float-md-end">
                                    <Form.Check
                                        disabled={this.state.activating}
                                        type="switch"
                                        label={this.state.activating ? <Spinner animation="border" size="sm" /> : (this.state.isActive ? <><Image src="/images/icons/eye.svg" width={14} className="pointer"/> опубликовано</> : <><Image src="/images/icons/eye-slash.svg" width={14} className="pointer"/> скрыто</>)}
                                        reverse
                                        checked={this.state.isActive}
                                        onChange={this.handleChangeActive}
                                        id="disabled-custom-switch"
                                    />
                                </Form>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />
                    {!item.title && !loading && (
                        <h4>Объект не найден или был удален</h4>
                    )}

                    {item.title && !loading && (
                        <>
                            <div className="mb-5">

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <Row className="d-flex justify-content-md-between">
                                            <Col md={3}>
                                                <p className="small mb-0">ID: {item.id}</p>
                                            </Col>
                                            <Col md={9}>
                                                <p className="small float-md-end"> {item.uid === null ? <>URL-адрес не задан</> : <><Link to={global.publicUrl + item.uid} target="_blank">{global.publicUrl + item.uid}</Link>&nbsp;<Image src="/images/icons/copy.svg" width={14} className="pointer" onClick={() => {if (item.uid !== null) navigator.clipboard.writeText(global.publicUrl + item.uid)}}/></>} </p>

                                            </Col>
                                        </Row>

                                        <div className="mb-4">
                                            <h4>{item.title}</h4>
                                        </div>

                                        <Button variant="light" size="sm" onClick={() => this.setState({show_modal_update: true})}>Изменить</Button>

                                        <Modal show={show_modal_update} onHide={this.handleCloseUpdate} centered>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Изменить</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <Form>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Название</Form.Label>
                                                        <Form.Control type="text" placeholder="Экспонат" value={this.state.title} onChange={this.handleChangeTitle} />
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>URL-адрес</Form.Label>
                                                        <InputGroup className="mb-1">
                                                            <InputGroup.Text id="uri-pre">{global.publicUrl}</InputGroup.Text>
                                                            <Form.Control type="text" placeholder="qwerty" value={this.state.uid} onChange={this.handleChangeUID} aria-describedby="uri-pre" />
                                                        </InputGroup>
                                                        <Form.Text muted>Адрес, по которому доступна карточка. Может состоять только из цифр и латинских букв.</Form.Text>
                                                    </Form.Group>
                                                </Form>
                                            </Modal.Body>
                                            <Modal.Footer className="justify-content-between">
                                                <Button variant="light" disabled={updating} onClick={this.handleCloseUpdate}>
                                                    Закрыть
                                                </Button>
                                                <Button variant="dark" disabled={updating} onClick={this.update}>
                                                    Сохранить
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </div>
                                </div>



                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5><Image src="/images/icons/photo.svg" width={20}/> Фото</h5>
                                            {item.photo != null && (
                                                <img className="cover-preview-sm mt-2" src={item.photo} alt="Фото" />
                                            )}
                                            {item.photo === null && (
                                                <p className="small truncate-text">Не добавлено</p>
                                            )}
                                            
                                        </div>
                                        <Link to={window.location.pathname + "/photo"}>Изменить</Link>
                                    </div>
                                </div>


                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5 className="mb-3"><Image src="/images/icons/link.svg" width={20}/> Ссылки — внешние ресурсы</h5>
                                            {Object.keys(urlTypes).map(function(key) {
                                                return (
                                                    <div key={key}>
                                                        <div className="">
                                                            <p className="text-bold mb-0">{urlTypes[key].name}</p>
                                                            <div>
                                                                <p className="small truncate-text mb-1">
                                                                    {item.urls.findIndex(x => x.type === urlTypes[key].type) !== -1
                                                                    ? <Link to={item.urls.find(x => x.type === urlTypes[key].type).url} target="_blank">{item.urls.find(x => x.type === urlTypes[key].type).url}</Link>
                                                                    : <>Не добавлена</>}
                                                                </p>
                                                            </div>
                                                            
                                                        </div>

                                                        {urlTypes.length - 1 > key && (
                                                            <hr />
                                                        )}
                                                        
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <Link to={window.location.pathname + "/urls"}>Изменить</Link>
                                    </div>
                                </div>

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5 className="truncate-text"><Image src="/images/icons/video.svg" width={20}/> Русский жестовый язык с субтитрами</h5>
                                            <p></p>
                                            <p className="small truncate-text">{item.video === null ? "Не добавлено" : "Файл добавлен: " + item.video.split("/").pop()}</p>
                                        </div>
                                        <Link to={window.location.pathname + "/video"}>Изменить</Link>
                                    </div>
                                </div>

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5><Image src="/images/icons/audio.svg" width={20}/> Тифлокомментирование</h5>
                                            {/*
                                            <p className="small truncate-text">{item.audio === null ? "Не добавлено" : "Файл добавлен: " + item.audio.split("/").pop()}</p>
                                            */}
                                            {item.audio.length > 0 && (
                                                <div className="mt-3">
                                                    {Object.keys(item.audio).map(function(key) {
                                                        return (<p key={key} className="mb-0 small truncate-text">{parseInt(key) + 1}. {item.audio[key].title}</p>)
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                        <Link to={window.location.pathname + "/audio"}>Изменить</Link>
                                    </div>
                                </div>

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5><Image src="/images/icons/text.svg" width={20}/> Ясный язык</h5>
                                            <p className="small truncate-text-lines">{item.text === null ? "Не заполнено" : item.text.replace(/<[^>]*>?/gm, '')}</p>
                                        </div>
                                        <Link to={window.location.pathname + "/editor"}>Редактировать</Link>
                                    </div>
                                </div>

                            </div>

                            
                            <div>

                                <Link className="text-danger" onClick={() => this.setState({show_modal_delete: true})}>Удалить</Link>
                                {/*
                                    <Button variant="danger" size="sm" onClick={() => this.setState({show_modal_delete: true})}>Удалить</Button>
                                */}
                                <Modal show={show_modal_delete} onHide={this.handleCloseDelete} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Удалить</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <p>Вы действительно хотите безвозвратно удалить информацию по объекту &#171;{item.title}&#187;?</p>
                                    </Modal.Body>
                                    <Modal.Footer className="justify-content-between">
                                        <Button variant="light" disabled={deleting} onClick={this.handleCloseDelete}>
                                            Нет
                                        </Button>
                                        <Button variant="danger" disabled={deleting} onClick={this.delete}>
                                            Да
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                            
                        </>
                    )}
                    
                </Col>
            </Row>
            </>
        )

    }
}

export default withRouter(Item);